export function parseIntOrNull(val: any) {
    if (!val) { return null; }
    const parsed = parseInt(val);
    return isNaN(parsed) ? null : parsed;
} 

export function fromLocaleString(str: string): number {
    if (!str || !str.length) {
        return null;
    }

    const test = 1.1;
    const decSep = test.toLocaleString().substring(1, 2);
    const reg = new RegExp(`[^0-9${decSep}]`, 'g');
    let clean = str.replace(reg, '');
    clean = clean.replace(decSep, '.');
    
    return parseFloat(clean);
}

export function toLocalFixed(number: number, fraction: number): string {
    if (fraction == undefined || fraction == null || fraction === -1) {
        return number.toLocaleString();
    }
    return number.toLocaleString(undefined, { minimumFractionDigits: fraction, maximumFractionDigits: fraction });
}

export function caseInsensitiveEquals(str1: string, str2: string) {
    return typeof str1 === 'string' && typeof str2 === 'string'
        ? str1.trim().toLowerCase() === str2.trim().toLowerCase()
        : str1 === str2;
}
